import { inject, Injectable, signal } from '@angular/core';
import { MhsInternalApiClient, ModuleDto, TenantDto } from '../api/mhsInternalApiClient';
import { toObservable, toSignal } from '@angular/core/rxjs-interop';
import { StorageService } from '../context/storageService';
import { Observable } from 'rxjs/internal/Observable';
import { distinctUntilChanged, filter, map, of, switchMap, tap } from 'rxjs';
import { AuthStore } from '../authentication/authStore';
import { TenantStore } from '../context/tenantStore';
import { UsertStore } from '../context/userStore';

@Injectable({
  providedIn: 'root',
})
export class TenantService {
  interalApiClient = inject(MhsInternalApiClient);
  localStorageService = inject(StorageService);
  authStore = inject(AuthStore);

  readonly avilableTenants = toSignal(this.loadTenants(), { initialValue: [] });

  loadTenants(): Observable<TenantDto[]> {
    if (this.localStorageService.get('tenants')) {
      const tenants = JSON.parse(this.localStorageService.get('tenants') || '[]');
      return of(tenants);
    }

    return toObservable(this.authStore.accessToken).pipe(
      switchMap((token) => {
        if (!token) {
          return of([]);
        }
        return this.interalApiClient.manage_GetTenants().pipe(
          tap((tenants) => {
            //this.avilableTenants.set(tenants);
            this.localStorageService.set('tenants', JSON.stringify(tenants));
          }),
        );
      }),
    );
  }
}
